var navLinks = document.querySelectorAll('.cus_support_nav_links a'); // Replace with the actual class or ID of your navigation menu
navLinks.forEach(function(link) {
  if (link.hostname !== window.location.hostname) {
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }
});

let modalsElement = document.querySelectorAll('[data-wau-modal-content]');
if (modalsElement.length > 0) {
  modalsElement.forEach(modal => {
    WAU.Modal.init(modal.dataset.wauModalContent);
  });
} 
if (document.querySelector('.top-product-tabs') != undefined) {
  productTabsResize()
  window.addEventListener('resize', function(event) {
    productTabsResize()
  }, true);
} 
function productTabsResize(){
  if ( WAU.Helpers.isDevice() ) {
    document.querySelector('.top-product-tabs').style.display = "block";;
  } else {
    let tabElement = document.querySelector('.top-product-tabs');
    document.querySelector('.product-block--variants').after(tabElement);
  }
}
// Replace with your actual Shopify-hosted CSV URL
const csvUrl = 'https://cdn.shopify.com/s/files/1/1667/4225/files/costcalculator.csv';
// Helper function to load and parse CSV
async function loadCSV(url) {
  const response = await fetch(url);
  const text = await response.text();
  
  const rows = text.trim().split('\n');
  const headers = rows[0].split(',').map(h => h.trim());
  return rows.slice(1).map(row => {
    const values = row.split(',').map(v => v.trim());
    return headers.reduce((obj, header, idx) => {
      obj[header] = values[idx];
      return obj;
    }, {});
  });
}
// Global variable to hold the CSV data
let csvData = [];

// Initialize
(async function() {
  csvData = await loadCSV(csvUrl);
})();

// Attach event listeners
document.querySelectorAll(".select-your-grain button").forEach(p => p.addEventListener('click', onGrainSelection));

function onGrainSelection(e) {
  document.querySelectorAll(".select-your-grain").forEach(p => p.classList.remove('active'));
  e.target.closest(".select-your-grain").classList.toggle("active");
  calculateData();
}

document.querySelectorAll(".pick-your-category button").forEach(p => p.addEventListener('click', onPickCategorySelection));

function onPickCategorySelection(e) {
  document.querySelectorAll(".pick-your-category").forEach(p => p.classList.remove('active'));
  e.target.closest(".pick-your-category").classList.toggle("active");
  calculateData();
}

document.querySelectorAll(".choose-your-type button").forEach(p => p.addEventListener('click', onChooseTypeSelection));

function onChooseTypeSelection(e) {
  document.querySelectorAll(".choose-your-type").forEach(p => p.classList.remove('active'));
  e.target.closest(".choose-your-type").classList.toggle("active");
  calculateData();
}

function calculateData(){
  //calculate based on selection
  const nutGrain = document.querySelector('.select-your-grain.active p').innerHTML;
  const category = document.querySelector('.pick-your-category.active p').innerHTML;
  const type = document.querySelector('.choose-your-type.active p').innerHTML;
  csvData.find(row => 
    {
      //"Ingredient,milk creamer,Organic Conventional,Store-Bought,Homemade,Weekly Savings,Monthly Savings,Yearly Savings"
      if(row['Ingredient'] === nutGrain &&
      row['milk creamer'] === category &&
      row['Organic Conventional'] === type){
        document.querySelector('.storebought p').innerHTML = row['Store-Bought'];
        document.querySelector('.homemade p').innerHTML = row['Homemade'];
        document.querySelector('.weekly-price p').innerHTML = row['Weekly Savings'];
        document.querySelector('.monthly-price p').innerHTML = row['Monthly Savings'];
        document.querySelector('.yearly-price p').innerHTML = row['Yearly Savings'];
      }
    }
  );
  var message = '<strong>Weekly Consumption</strong>: We estimate the average person drinks <strong>58 oz of plant-based milk per week</strong>.';
  if(nutGrain == 'Almond'){
    message = '<li>Our almonds are not organic</li>';
  } else if(nutGrain == 'Cashew'){
    message = '<li>Our cashews are organic yet still save you money compared to purchasing conventional cashew milks!</li>';
  } else if(nutGrain == 'Oats'){
    message = '<li>Our whole grain oats are organic yet still save you money compared to purchasing conventional oat milks!</li>';
  } else if(nutGrain == 'Coconut'){
    message = '<li>Our coconut shreds are organic yet still save you money compared to purchasing conventional coconut milks!</li>';
  }
  if(nutGrain == 'Cashew' && category == 'Milk' && type == 'Organic'){
    message = '<li>There are no organic cashew creamers we could find for sale outside of food service distributors; we\'re instead using the average price for organic cashew milks which should be similar if not cheaper.</li>';
  }
  if(category == 'Milk'){
    message += "<li>Prices shown for milk made in ACH assume each batch is made with water at the MAX water level.</li>"
  }
  if(message != ''){
    document.querySelector('.selected-message').innerHTML = '<ul>'+message+'</ul>';
    document.querySelector('.deafult-message').classList.add('hide');
    document.querySelector('.selected-message').classList.add('show');
  }else{
    document.querySelector('.deafult-message').classList.remove('hide');
    document.querySelector('.selected-message').classList.remove('show');
  }
}
if (document.querySelector('.article-hero .cus_iframe_wrapper .video-img') != undefined) {
  document.querySelector('.article-hero .cus_iframe_wrapper .video-img').addEventListener('click',function(e){
    document.querySelector('.article-hero .cus_iframe_wrapper .video-img').classList.add('hide');
    const iframeElem = document.querySelector(".article-hero .cus_iframe_wrapper .iframe-video iframe");
    var videoSrc = iframeElem.getAttribute('data-src');
    
    const isDriveUrl = /https?:\/\/(www\.)?drive\.google\.com\/(file|open|drive)\/?/i.test(videoSrc);

    if(isDriveUrl){
      iframeElem.setAttribute('src', videoSrc);
    
    }else{
      const vidUrl = videoSrc.split("?");
      let vidUrl0 = vidUrl[0];
      if (vidUrl0.includes("//vimeo.com/")) {
        const vimeoIdMatch = vidUrl0.match(/vimeo\.com\/(\d+)/);
        if (vimeoIdMatch && vimeoIdMatch[1]) {
          vidUrl0 = `//player.vimeo.com/video/${vimeoIdMatch[1]}`;
        }
      }
      iframeElem.setAttribute('src', vidUrl0+ '?autoplay=1');
    }
    document.querySelector(".article-hero .cus_iframe_wrapper .iframe-video").classList.toggle("show");
  });
} 
if(document.querySelector('[btn-label="Reviews"]')  != undefined ){
  setTimeout(() => {
    document.querySelector('[btn-label="Reviews"]').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"> \
                  <g clip-path="url(#clip0_195_559)"> \
                  <path d="M14.1299 0.019928H3.87012C2.01074 0.019928 0.50332 1.53067 0.5 3.39005V11.299C0.50332 13.1584 2.01074 14.6691 3.87012 14.6691H6.66582L8.49863 16.7576C8.74102 17.0332 9.15938 17.0598 9.43496 16.8174C9.45488 16.7975 9.4748 16.7809 9.49473 16.7576L11.3275 14.6691H14.1232C15.9859 14.6691 17.4934 13.1584 17.4934 11.299V3.39005C17.4967 1.52735 15.9893 0.019928 14.1299 0.019928ZM13.157 11.2193H4.84297C4.47773 11.2193 4.17891 10.9205 4.17891 10.5553C4.17891 10.19 4.47773 9.89122 4.84297 9.89122H13.157C13.5223 9.89122 13.8211 10.19 13.8211 10.5553C13.8211 10.9205 13.5223 11.2193 13.157 11.2193ZM13.157 7.96544H4.84297C4.47773 7.96544 4.17891 7.66661 4.17891 7.30137C4.17891 6.93614 4.47773 6.63731 4.84297 6.63731H13.157C13.5223 6.63731 13.8211 6.93614 13.8211 7.30137C13.8211 7.66661 13.5223 7.96544 13.157 7.96544ZM13.157 4.71153H4.84297C4.47773 4.71153 4.17891 4.4127 4.17891 4.04747C4.17891 3.68223 4.47773 3.3834 4.84297 3.3834H13.157C13.5223 3.3834 13.8211 3.68223 13.8211 4.04747C13.8211 4.4127 13.5223 4.71153 13.157 4.71153Z" fill="currentColor"/> \
                  </g> \
                  <defs> \
                  <clipPath id="clip0_195_559"> \
                  <rect width="17" height="17" fill="currentColor" transform="translate(0.5)"/> \
                  </clipPath> \
                  </defs> \
                </svg> \
                <span>Reviews</span>';
  }, 500);
}
document.querySelector('.btn-print').addEventListener('click',function(e){
  window.print();
});
function displayFirstAccordion(){
  if(window.innerWidth < 769){
    setTimeout(() => {
      if(document.querySelector('[aria-type="shop-all"]')){
        document.querySelector('[aria-type="shop-all"]').parentElement.classList.add('accordion-expanded');
        // document.querySelector('[aria-type="shop-all"]').click();
        document.querySelector('[aria-panel-type="shop-all"]').style.display='block';
        document.querySelector('[aria-panel-type="shop-all"]').removeAttribute('hidden');
      }
    }, 1500);
  }
}
displayFirstAccordion();
window.addEventListener('resize', function() {
  displayFirstAccordion();
});